import { Component, OnInit, Input } from '@angular/core';

import { ViewCell } from '@app/shared/smart-table/ng2-smart-table';
import { SensorService } from '@app/core/sensor.service';

@Component({
  standalone: false,
  selector: 'app-sensor-name',
  template: `
    {{ renderValue }}
  `
})
export class SensorNameComponent implements OnInit, ViewCell {
  @Input() value: string;
  @Input() rowData: any;

  public renderValue: string;
  sensorTypes = this.sensorService.sensorTypesFixed;

  constructor(private sensorService: SensorService) {}

  ngOnInit() {
    if (this.sensorTypes) {
      const index = this.sensorTypes.findIndex(s => s.value === this.value);
      if (index !== -1) {
        this.renderValue = this.sensorTypes[index].name;
      }
    }
  }
}
